import { render, staticRenderFns } from "./addClb.vue?vue&type=template&id=174e46bf&scoped=true"
import script from "./addClb.vue?vue&type=script&lang=js"
export * from "./addClb.vue?vue&type=script&lang=js"
import style0 from "./addClb.vue?vue&type=style&index=0&id=174e46bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e46bf",
  null
  
)

export default component.exports